module.exports = __webpack_public_path__ + "img/local-supplier-badge.53c10cf4.svg";